import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditorComponent } from './components/editor/editor.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { ViewComponent } from './components/view/view.component';
import { StocksComponent } from './components/stocks/stocks.component';
import { DuotoneComponent } from './components/duotone/duotone.component';

const routes: Routes = [
  { path: '', component: EditorComponent, canActivate: [AuthGuard] },
  { path: 'stocks', component: StocksComponent, canActivate: [AuthGuard] },
  { path: 'results', component: ViewComponent, canActivate: [AuthGuard] },
  { path: 'duotone', component: DuotoneComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: '**', component: EditorComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
